export const ADVERT_ITEM = 'item'
export const ADVERT_EDIT = 'edit'
export const ADVERT_LIST = 'list'
export const ADVERT_FILTER_LIST = 'filterList'
export const ADVERT_SUGGEST = 'suggest'
export const ADVERT_SIMILAR = 'similar'
export const ADVERT_MY_ADVERT = 'myAdvert'
export const ADVERT_COMPLAIN_LIST = 'complainList'
